/**
 * Default filter group configuration for UserSearchPanel.
 *
 * Each entry describes a filterable dimension with the key that appears on
 * PanelUser, a human-readable label, and an options array of [value, label]
 * pairs.  These map directly to the real filter dimensions in
 * src/components/UserFilters.tsx (gender, onboardingStep, interviewTopic,
 * accountStatus, membershipType, userType) plus the design's own additions.
 *
 * UserSearchPanel accepts this array via the `filterGroups` prop; this const
 * is the sensible default that callers can pass, override, or extend.
 */

export interface FilterGroup {
  key: string;
  label: string;
  options: [string, string][];
}

export const defaultUserFilterGroups: FilterGroup[] = [
  {
    key: 'gender',
    label: 'Gender',
    options: [
      ['female', 'Female'],
      ['male', 'Male'],
      ['nonbinary', 'Non-binary'],
    ],
  },
  {
    key: 'step',
    label: 'Onboarding step',
    options: [
      ['start', 'Start'],
      ['ready_interview', 'Ready for Interview'],
      ['interview', 'Interview'],
      ['upload_photo', 'Upload Photo'],
      ['plan_comparison', 'Plan Comparison'],
      ['subscription', 'Subscription'],
      ['review_profile', 'Review Profile'],
      ['completed', 'Completed'],
    ],
  },
  {
    key: 'topic',
    label: 'Interview topic',
    options: [
      ['not_started', 'Not started'],
      ['init', 'Init'],
      ['lifestyle', 'Life Style'],
      ['family', 'Family'],
      ['relationship', 'Relationship'],
    ],
  },
  {
    key: 'status',
    label: 'Account status',
    options: [
      ['active', 'Active'],
      ['blocked', 'Blocked'],
      ['paused', 'Paused'],
      ['skip_match', 'Skip Match'],
    ],
  },
  {
    key: 'plan',
    label: 'Membership',
    options: [
      ['freemium', 'Freemium'],
      ['premium_trial', 'Premium Trial'],
      ['premium', 'Premium'],
    ],
  },
  {
    key: 'type',
    label: 'User type',
    options: [
      ['normal', 'Normal'],
      ['sample', 'Sample'],
      ['test', 'Test'],
    ],
  },
];
